import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getCaptcha, requestPassword} from '../core/_requests'
import {KTSVG} from "../../../../_metronic/helpers";

const initialValues = {
  email: 'admin@demo.com',
  captcha: ''
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  captcha: Yup.string()
      .min(4, ' تصویر امنیتی وارد شده معتبر نمیباشد')
      .max(4, 'تصویر امنیتی وارد شده معتبر نمیباشد')
      .required('تصویر امنیتی اجباری میباشد'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [captcha, setCaptcha] = useState("");
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email, values.captcha)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('اطلاعات وارد شده معتبر نمیباشد')
          })
      }, 1000)
    },
  })
  async function refreshCaptcha() {
    try {
      const {data: captchaData} = await getCaptcha();
      setCaptcha(captchaData);
    } catch {

    }
  }
  useEffect(() => {
        refreshCaptcha()
      },
      [])
  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>بازیابی رمز عبور</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
          لطفاً ایمیل خود را وارد نمایید...
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>
            اطلاعات وارد شده معتبر نمیباشد ، لطفاً مجددا تلاش نمایید          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>Sent password reset. Please check your email</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>آدرس ایمیل</label>
        <input
          type='email'
          placeholder=''
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      {/* begin::Form group */}
      <div className='fv-row mb-10 row'>
        <div className="col-6">
          <label className='form-label fs-6 fw-bold text-dark'>تصویر امنیتی</label>

          <input
              placeholder='تصویر امنیتی '
              {...formik.getFieldProps('captcha')}
              className={clsx(
                  'form-control form-control-lg form-control-solid ',
                  {'is-invalid': formik.touched.captcha && formik.errors.captcha},
                  {
                    'is-valid': formik.touched.captcha && !formik.errors.captcha,
                  }
              )}
              type='text'
              name='captcha'
              autoComplete='off'
          />
          {formik.touched.captcha && formik.errors.captcha && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.captcha}</span>
              </div>
          )}
        </div>

        <div className="col-6 ">
          <label className='form-label fs-6 fw-bold text-dark'>تصویر </label>
          <div className="row">
            <div className="col-8">
              <img src={captcha} className="col-8" alt=""/>
            </div>
            <div className="col-4">
              <button onClick={refreshCaptcha} className="btn btn-light-primary me-3">

                <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-2'/>

              </button>
            </div>

          </div>


        </div>

      </div>
      {/* end::Form group */}
      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4'>
          <span className='indicator-label'>تایید</span>
          {loading && (
            <span className='indicator-progress'>
             در حال بارگزاری...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            لغو
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
